import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BootstrapAthleteComponent } from "./components/bootstrap-athlete/bootstrap-athlete.component";
import { ProxyAthleteComponent } from './components/proxy-athlete/proxy-athlete.component';

const routes: Routes = [
  {
    path: 'photos/:id',
    component: ProxyAthleteComponent
  },
  {
    path: ':id',
    component: BootstrapAthleteComponent,
  },
  {
    path: ":id/:name",
    component: BootstrapAthleteComponent,
    data: {
      reuse: true
    },
    children: [
      {
        path: "biography",
        loadChildren:
          "./athlete-biography/athlete-biography.module#AthleteBiographyModule",
        data: {
          reuse: true
        }
      },

      // Redirections for insights.
      {
        path: "biography/statistics",
        redirectTo: "statistics"

      },
      {
        path: "biography/records",
        redirectTo: "records"

      },
      {
        path: "biography/results",
        redirectTo: "results"

      },

      // END redirections
      {
        path: "statistics",
        loadChildren:
          "./athlete-statistics/athlete-statistics.module#AthleteStatisticsModule",
        data: {
          reuse: true
        }
      },
      {
        path: "matches",
        loadChildren:
          "./athlete-matches/athlete-matches.module#AthleteMatchesModule",
        data: {
          reuse: true
        }
      },
      {
        path: "results",
        loadChildren:
          "./athlete-results/athlete-results.module#AthleteResultsModule",
        data: {
          reuse: true
        }
      },
      {
        path: "records",
        loadChildren:
          "./athlete-records/athlete-records.module#AthleteRecordsModule",
        data: {
          reuse: true
        }
      },
      {
        path: "photos",
        loadChildren:
          "./athlete-photos/athlete-photos.module#AthletePhotosModule",
        data: {
          reuse: true
        }
      },
      {
        path: "news",
        loadChildren:
          "./athlete-news/athlete-news.module#AthleteNewsModule",
        data: {
          reuse: true
        }
      },
      {
        path: "quotes",
        loadChildren: () => import('./athlete-quotes/athlete-quotes.module').then(m => m.AthleteQuotesModule),
        data: {
          reuse: true
        }
      },
      {
        path: "world-cup",
        loadChildren: () => import('./athlete-wcup-ranking/athlete-wcup-ranking.module').then(m => m.AthleteWcupRankingModule),
        data: {
          reuse: true
        }
      }
    ],

  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AthleteRoutingModule { }
